export default "__VITE_ASSET__be0e3543__"